/**
 * Stable redirect URI for Keycloak (no hash or OAuth query params).
 * KC26 adds iss/code to the fragment; using window.location.href as redirect_uri
 * causes those params to accumulate on each login attempt.
 */
export function getKeycloakRedirectUri() {
  return `${window.location.origin}${window.location.pathname}`;
}

export function getKeycloakLogoutRedirectUri() {
  if (process.env.VUE_APP_KEYCLOAK_REDIRECT_URI) {
    return process.env.VUE_APP_KEYCLOAK_REDIRECT_URI;
  }

  return `${window.location.origin}/`;
}

export function getSilentCheckSsoRedirectUri() {
  return `${window.location.origin}/silent-check-sso.html`;
}

const KEYCLOAK_CALLBACK_HASH_PATTERN = /(^#|[&?])(code|state|session_state|iss)=/;

export function hasKeycloakCallbackHash(hash = window.location.hash) {
  return KEYCLOAK_CALLBACK_HASH_PATTERN.test(hash || '');
}

export function clearKeycloakCallbackHash() {
  if (!hasKeycloakCallbackHash()) {
    return;
  }

  const cleanUrl = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState(window.history.state, document.title, cleanUrl);
}

export function clearKeycloakCallbackStorage() {
  Object.keys(localStorage)
    .filter((key) => key.startsWith('kc-callback-'))
    .forEach((key) => localStorage.removeItem(key));
}

/**
 * Clear OAuth params from the browser URL. Use window.location.hash only —
 * Vue Router's to.hash can remain stale after replaceState.
 */
export function resolveKeycloakCallbackHash(next) {
  if (!hasKeycloakCallbackHash()) {
    next();
    return;
  }

  clearKeycloakCallbackHash();
  next();
}
